var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link, BrowserRouter as Router } from 'react-router-dom';
import Icon from '..';
var IconLink = function (_a) {
    var iconLink = _a.iconLink, icon = _a.icon;
    return (_jsx(Router, { children: _jsx(Link, __assign({ to: iconLink }, { children: _jsx(Icon, { icon: icon }, void 0) }), void 0) }, void 0));
};
export default IconLink;
